<template>
    <div class="modal-content">
        <div class="modal-header border-0 text-center">
            <modal-close />
            <div class="modal-title">
                <h2 class="h3 px-2 pt-3 pb-1" v-text="'Przerwanie promocji'" />
                <h3 class="h5 px-2" v-text="promotion.name" />
            </div>
        </div>
        <div class="modal-body p-x-4 py-2 text-primary">
            <!-- Disclaimer -->
            <div
                class="flex-grow-1 text-sm a-infoBar mb-4"
                :class="warning.cssClass"
                v-text="warning.text"
            />

            <p
                class="h6"
                v-text="'Wybierz sklepy, w których chcesz przerwać promocję:'"
            />

            <div class="d-flex pb-3 pt-1 border-bottom flex-column">
                <mass-selection-buttons
                    :select-all-data="selectAllData"
                    @select="selectAllShops($event)"
                />

                <div class="scrollbar w-100 mt-2">
                    <stop-subscription
                        v-for="(sub, idx) in searchedShops"
                        :key="idx"
                        :subscription="sub"
                    />
                </div>
            </div>
        </div>
        <div class="text-center">
            <button
                class="my-3 btn btn-custom-danger mt-2"
                id="stop-promos-btn"
                :disabled="loader"
                @click="stopPromotion"
            >
                Przerwij promocję

                <button-spinner
                    v-if="loader"
                    class="ml-3"
                    status="loading"
                />
            </button>

            <div
                v-if="updateError"
                class="w-100 text-sm text-danger mb-3"
            >
                Przerwanie promocji nie powiodło się.
                Napisz na <a href="mailto:bok@europlatform.pl">bok@europlatform.pl</a>
                lub zadzwoń na numer <a href="tel:48221291400">+48 22 12 91 400</a>
            </div>
        </div>
    </div>
</template>

<script>
import StopSubscription from '@/components/promotions/StopSubscription'

export default {
    data() {
        return {
            searchMerchants: '',
            loader: false,
            updateError: false
        }
    },
    components: {
        StopSubscription
    },
    computed: {
        promotion() {
            return this.$store.getters.getPromotion
        },
        subscriptions() {
            return this.$store.getters.getSubscriptionsToStop
        },
        merchants() {
            return this.$store.getters.getAvailableMerchants
        },
        searchedShops() {
            const shopsArray = this.subscriptions.map(el => el.merchant_id)
            const merchants = this.merchants
                .filter(el => shopsArray.includes(el.id))
                .filter(item => {
                    return item.name
                        .toLowerCase()
                        .includes(this.searchMerchants.toLowerCase())
                })
                .map(item => item.id)

            const filteredSubs = this.subscriptions.filter(shop => {
                return merchants.includes(shop.merchant_id)
            })
            return filteredSubs
        },
        selectAllData: {
            get() {
                return this.$store.getters.getSelectSubsToStop
            },
            set(value) {
                this.selectAllShops(value)
            }
        },
        warning() {
            const lockedAt = this.promotion.locked_at
            const today = this.$moment()

            let text = 'Uwaga! Ponowna aktywacja promocji będzie możliwa jutro.'
            let cssClass = 'a-infoBar--warning'

            if (lockedAt && this.$moment(lockedAt).isBefore(today)) {
                text =
                    'Uwaga! Ponowna aktywacja promocji nie będzie możliwa, gdyż ostateczny termin na jej aktywację upłynął.'
                cssClass = 'a-infoBar--error'
            }

            return {
                text,
                cssClass
            }
        }
    },
    methods: {
        async stopPromotion() {
            this.loader = true

            const { status, data } = await this.$store.dispatch(
                'subscriptionsQueue', {
                    state: 'interrupted'
                }
            )

            if (status !== 200 || !data?.data) {
                // Handle error
                throw new Error(data.message || 'Error subscriptionsQueue')
            }

            const queueId = data.data.queue_id
            const checkProgress = async () => {
                // Check progress request
                const { status, data } = await this.$store.$api.get(
                    `subscriptionQueueProgress/${queueId}`
                )

                if (status !== 200) {
                    // Handle error
                    throw new Error(data?.message || 'Error GET progress')
                }

                return data.data
            }

            let progress = await checkProgress()

            const waitForCompletion = async () => {
                const { status, processed, total } = await progress

                if (status === 'waiting' || status === 'processing') {
                    // If not done yet, wait 1.5s and check again
                    await new Promise(resolve => setTimeout(resolve, 1500))

                    // Check progress
                    progress = await checkProgress()

                    // Recursively do the function again
                    await waitForCompletion()
                }

                if (status === 'error' || processed !== total) {
                    // Show error notification
                    this.updateError = true

                    this.loader = false
                    return
                }

                // All good, close modal and show success notification
                this.$store.dispatch('toggleModal', false)

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Przerwano promocję w wybranych sklepach'
                })

                this.$store.dispatch('loadPromotion', {
                    promoId: this.$route.params.id,
                    includes: 'infographic,company,logo,company.logo,terms'
                })
            }

            await waitForCompletion()
        },

        selectAllShops(value) {
            this.$store.dispatch('selectAllSubsToStop', value)
            this.$store.dispatch('setSelectAllSubsToStop', value)
        }
    }
}
</script>
